import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";

// Message
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useMessagesList() {
  // Use toast
  const toast = useToast();

  const refMessageListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    // { key: "id", label: "編號", sortable: true, class: 'sticky-column' },
    { key: "order_number", label: "單號", class: 'sticky-column' },
    { key: "is_read", label: "是否已讀", class: 'sticky-column' },
    { key: "actions", label: "操作", class: 'sticky-column' },
    { key: "users", label: "接收用戶"},
    { key: "user_type.type", label: "接收群" },
    { key: "address", label: "地址", sortable: true },
    { key: "content", label: "內容", sortable: true },
    { key: "created_at", label: "創建日期", sortable: true },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const messagesList = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refMessageListTable.value
      ? refMessageListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refMessageListTable.value.refresh();
  };

  watch(
    [currentPage, perPage, searchQuery ],
    () => {
      refetchData();
    }
  );

  const fetchMessages = (ctx, callback) => {
  
    
    store
      .dispatch("message/fetchMessages", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then((response) => {
        const { messages, total } = response.data;
        callback(messages);
        totalRow.value = total;
        messagesList.value = messages
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取貸款清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const userTypeOptions = ref([]);
 

  const refetchOption = () => {
    store
      .dispatch("app/fetchOptionList", {
        user_types: true,
      })
      .then((response) => {
        userTypeOptions.value = response.data.user_types;
      });
  };

  onMounted(() => {
    refetchOption();
  });

  return {
    fetchMessages,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    messagesList,
    refMessageListTable,
    ability,
    refetchData,
    userTypeOptions
   
  };
}
